<template>
  <b-form-group
    label="Nilai Perolehan"
    label-for="nilaiPerolehan"
    label-class="pb-0 pt-0"
  >
    <b-form-input
      v-model="nilaiPerolehan"
      disabled
    />
  </b-form-group>
</template>
<script>
export default {
  props: {
    nilaiPerolehan: { type: String, default: '' },
  },
}
</script>
